import { render, staticRenderFns } from "./DispositivosRedonda.vue?vue&type=template&id=44a1d670&scoped=true"
import script from "./DispositivosRedonda.vue?vue&type=script&setup=true&lang=js"
export * from "./DispositivosRedonda.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DispositivosRedonda.vue?vue&type=style&index=0&id=44a1d670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1d670",
  null
  
)

export default component.exports